export const GET_AREAS_LIST = "GET_AREAS_LIST";
export const GET_AREAS_LIST_SUCCESS = "GET_AREAS_LIST_SUCCESS";

export const ADD_NEW_AREA = "ADD_NEW_AREA";
export const ADD_AREA_SUCCESS = "ADD_AREA_SUCCESS";
export const ADD_AREA_FAIL = "ADD_AREA_FAIL";

export const AREA_UPDATE = "AREA_UPDATE";
export const UPDATE_AREA_SUCCESS = "UPDATE_AREA_SUCCESS";
export const UPDATE_AREA_FAIL = "UPDATE_AREA_FAIL";

export const DELETE_AREA = "DELETE_AREA";
export const DELETE_AREA_SUCCESS = "DELETE_AREA_SUCCESS";
export const DELETE_AREA_FAIL = "DELETE_AREA_FAIL";

export const MODAL_AREA_SHOW = "MODAL_AREA_SHOW";


export const getAreas = (data) => ({
    type: GET_AREAS_LIST,
    payload: data,
  });
  
  export const getAreasSuccess = areas => ({
    type: GET_AREAS_LIST_SUCCESS,
    payload: areas,
  });
  
  export const getAreasFail = error => ({
    type: GET_AREAS_FAIL,
    payload: error,
  });
  
  export const addNewArea = area => ({
    type: ADD_NEW_AREA,
    payload: area,
  });
  
  export const addAreaSuccess = area => ({
    type: ADD_AREA_SUCCESS,
    payload: area,
  });
  
  export const addAreaFail = error => ({
    type: ADD_AREA_FAIL,
    payload: error,
  });
  
  export const updateArea = area => ({
    type: AREA_UPDATE,
    payload: area,
  });
  
  export const updateAreaSuccess = area => ({
    type: UPDATE_AREA_SUCCESS,
    payload: area,
  });
  
  export const updateAreaFail = error => ({
    type: UPDATE_AREA_FAIL,
    payload: error,
  });
  
  export const deleteArea = area => ({
    type: DELETE_AREA,
    payload: area,
  });
  
  export const deleteAreaSuccess = area => ({
    type: DELETE_AREA_SUCCESS,
    payload: area,
  });
  
export const deleteAreaFail = error => ({
    type: DELETE_AREA_FAIL,
    payload: error,
  });

export const modalAreaShow = flag => ({
    type: MODAL_AREA_SHOW,
    payload:flag,
})